import LicenseTableCard from './LicenseTableCardConnector';

export default LicenseTableCard;
